import { render } from "./PedidosFacturasPendientes.vue?vue&type=template&id=2f64e3d6&scoped=true"
import script from "./PedidosFacturasPendientes.vue?vue&type=script&lang=ts"
export * from "./PedidosFacturasPendientes.vue?vue&type=script&lang=ts"

import "./PedidosFacturasPendientes.vue?vue&type=style&index=0&id=2f64e3d6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2f64e3d6"

export default script